module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-contaier"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.index',
        query: {
          filter: 'created'
        }
      }
    }
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "waiting-processed"
  }, [_c('div', {
    staticClass: "number-container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.number) + " "), _c('i', {
    staticClass: "el-icon-download"
  })])])]) : _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23b070cb","hasScoped":false}!./src/app/components/widgets/waitingProcessed/waitingProcessed.html
// module id = 2941
// module chunks = 1